import { ref, watch, } from 'vue';
import { dayjs, message } from '@/utils/js/initVariable';
import { ElLoading } from 'element-plus';

const sensorList = ['SAR卫星（10m）', '标清光学卫星（10m）', '高清光学卫星（3m）', '超清光学卫星（0.75m）'];

const sensorType = (val)=>{
  switch(val){
    case '普清光学卫星（10m）': return 'LD_Satellite';
    case 'SAR卫星（10m）': return 'SAR_Satellite';
    case '标清光学卫星（10m）': return 'SD_Satellite';
    case '高清光学卫星（3m）': return 'HD_Satellite';
    case '超清光学卫星（0.75m）': return 'UC_Satellite';
    default: ;
  }
}

export default (layer, dateTimeFn, getImageFn)=>{
  // 请求相关参数
  const sensor = ref(), colorGroup = ref(), colorGroupList = ref([]), searchLoad = ref(false);
  watch(sensor, (newd, old)=>{
    if(newd){
      switch(newd){
        case '普清光学卫星（10m）': colorGroupList.value = ["普清真彩色", "普清假彩色"]; break;
        case 'SAR卫星（10m）': colorGroupList.value = ["垂直极化发射与接收（VV）", "垂直极化发射与水平极化接收（VH）"]; break;
        case '高清光学卫星（3m）': colorGroupList.value = ['高清真彩色']; break;
        case '标清光学卫星（10m）': colorGroupList.value = ["真彩色","假彩色","植被指数（NDVI）","水体指数（NDWI）","水汽指数（NDMI）"]; break;
        case '超清光学卫星（0.75m）': colorGroupList.value = ['超清真彩色']; break;
        default: 
          colorGroupList.value = [];
      }
      colorGroup.value = undefined;
    }else{
      colorGroupList.value = [];
      colorGroup.value = undefined;
    }
  })
  // layer 相关属性
  let bounds = layer.getBounds(),
      bbox = [
        bounds.getNorthWest().lng,
        bounds.getNorthWest().lat,
        bounds.getSouthEast().lng,
        bounds.getSouthEast().lat,
      ],
      center = layer.getCenter(),
      point = `[${center.lat.toFixed(6)},${center.lng.toFixed(6)}]`;
  // 日期选择器 属性&事件
  let requestDate = new Date();
  const dateTime =  ref(),
        disableTime = ref([]),
        disableCellNameFn = (date)=>{
          let list = disableTime.value.map((date)=>{
            return dayjs(date).format('YYYY-MM-DD');
          });
          if(list.includes(dayjs(date).format('YYYY-MM-DD'))){
            return '';
          }else{
            return 'disabled-date-cell';
          }
        },
        dateTimeChangeCreate = (panelClass)=>{
          return (val)=>{
            if(val && val.constructor == Date){
              requestDate = val;
            }
            if(!sensor.value){
              message('请选择传感器', 2);
              return;
            }
            if(!colorGroup.value){
              message('请选择色彩组合', 2);
              return;
            }
            let load = ElLoading.service({
              lock: true,
              target: `.${panelClass}`,
              background: 'var(--loadBackColor)',
            });
            dateTimeFn({
              boundingbox: bbox,
              sensor: sensorType(sensor.value),
              startTime: dayjs(requestDate).format('YYYY-MM-01'),
              endTime: dayjs(requestDate).endOf('month').format('YYYY-MM-DD'),
            }).then(res=>{
              if(res.data.code == 1004){
                disableTime.value = Array.from(Object.keys(res.data.data));
              }
            }).catch(err=>{
              console.log(err);
            }).finally(()=>{
              load.close();
            });
          }
        },
        imageRequestFn = (fn)=>{
          if(!sensor.value){
            message('请选择传感器', 2);
            return;
          }
          if(!colorGroup.value){
            message('请选择色彩组合', 2);
            return;
          }
          if(!dateTime.value){
            message('请选择请求时间', 2);
            return;
          }
          searchLoad.value = true;
          let list = disableTime.value.map((date)=>{
            return dayjs(date).format('YYYY-MM-DD');
          });
          getImageFn({
            boundingbox: bbox,
            colorName: colorGroup.value,
            dateTime: disableTime.value.at(
              list.indexOf(
                dayjs(dateTime.value).format('YYYY-MM-DD')
              )
            ),
            point,
          }).then(res=>{
            if(res.data.code == 1004){
              fn && fn(res.data.data);
            }
          }).catch(err=>{
            console.log(err);
          }).finally(()=>{
            searchLoad.value = false;
          });
        }
  return {
    sensorList, sensor, colorGroup, colorGroupList, searchLoad,
    dateTime, disableTime, disableCellNameFn, dateTimeChangeCreate, imageRequestFn,
  }
}